import { AppData } from "../../../types";
import { RemoveToastPayload } from "../../../actions";

export type RemoveToastOptions = {
  appData: AppData;
  payload: RemoveToastPayload;
};

export function removeToast({ appData, payload }: RemoveToastOptions): AppData {
  const { toast } = appData;
  const { id: idToRemove } = payload;
  const newToast = toast.filter(({ id }) => id !== idToRemove);
  return { ...appData, toast: newToast };
}
